import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
export default class ReminderService extends ApiService {
  template = "defaultTemplate";
  namespace = "reminder";
  icon = "Alarm";
  action = "action";
  favicon = "Alarm";

  Width = 600;
  DOMAIN = DOMAIN.REMINDER;

  constructor() {
    super("reminder");
  }
}
